export default __webpack_public_path__ + "static/media/action-refresh_white.c1dae527.svg";